export {}

declare global {
  const VIVENU: {
    onCheckoutCompleted?: (checkout: object) => void;
    onTicketPersonalized?: (ticketInfo: object) => void;
  }
}

const vivenuInit = () => {
  const script = document.createElement("script");
  script.src = "https://vivenu.com/web/deliver/js/v1/embed.js";
  script.async = true;

  script.onload = () => {
    if (VIVENU) {
      console.log("VIVENU loaded", VIVENU)
      VIVENU.onCheckoutCompleted = (checkout) => {
        console.log("Checkout completed:", checkout);
      };
      VIVENU.onTicketPersonalized = (ticketInfo) => {
        console.log("Ticket personalized:", ticketInfo);
      };
    } else {
      console.error("VIVENU is not available after script load");
    }
  };

  script.onerror = () => {
    console.error("Failed to load the VIVENU script.");
  };

  document.body.appendChild(script);
};

vivenuInit();
